import requestStatus from '../../constants/requestStatus';

export interface CustomError extends Error {
  statusCode?: number;
}

export type Action =
  | { type: 'initiate' }
  | { type: 'success'; payload: string }
  | { type: 'failure'; payload: CustomError };

export type State = {
  error: string | null;
  orderId?: string | null;
  status: 'initial' | 'fetching' | 'success' | 'failure';
};

const _initialState = {
  error: null,
  status: requestStatus.initial,
  orderId: null,
};

const getInitialState = (): State => ({ ..._initialState });

const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'initiate':
      return {
        error: null,
        status: requestStatus.fetching,
        orderId: null,
      };
    case 'success':
      return {
        error: null,
        status: requestStatus.success,
        orderId: action.payload,
      };
    case 'failure': {
      const statusCode = Number(action.payload.statusCode);
      let errorKey: string;
      if (statusCode === 403) {
        errorKey = 'error.dealersNotAllowed';
      } else if (statusCode === 409) {
        errorKey = 'error.alreadySubscribed';
      } else {
        errorKey = 'error.generic.long';
      }
      return {
        error: errorKey,
        status: requestStatus.failure,
        orderId: null,
      };
    }
    default:
      return _initialState;
  }
};

export { getInitialState, reducer };
